import { useState } from 'react'

import ApplyFormLabel from '../ApplyFormLabel'
import ApplyStepIcon from 'components/ApplyStepIcon'
import ApplyStepButtons from 'components/ApplyStepButtons'

import s from './ApplyFormSocial.module.css'
import * as Sentry from '@sentry/nextjs'

//TODO: setup proptypes
function ApplyFormSocial({ onSubmit, goBack, initialValues }) {
  const [fieldValues, setFieldValues] = useState({
    instagram: initialValues.instagram || '',
    snapchat: initialValues.snapchat || '',
    facebook: initialValues.facebook || '',
    twitter: initialValues.twitter || '',
    youtube: initialValues.youtube || '',
    tiktok: initialValues.tiktok || '',
    website: initialValues.website || '',
  })

  const handleAttrChange = (attr, val) => {
    const fields = { ...fieldValues }
    fields[attr] = val
    setFieldValues(fields)
  }

  const handleSubmit = (e) => {
    e.preventDefault()


    const submitValues = {...fieldValues, socialSubmitted: true}

    Sentry.addBreadcrumb({
      category: 'form',
      message: 'Social Submitted',
      level: 'debug',
      data: submitValues,
    })

    onSubmit(submitValues)
  }

  return (
    <div className={s.container}>
      <form onSubmit={handleSubmit}>
        <h1 className={s.title}>Social</h1>
        <p className={s.text}>
          If you would like us to checkout your social profiles please add them
          below
        </p>
        <div className={s.columns}>
          <div className={s.column}>
            <div className={s.field}>
              <ApplyFormLabel attr='instagram' label='Instagram' />
              <input
                type='text'
                placeholder='youraccount'
                id='instagram'
                name='instagram'
                value={fieldValues.instagram}
                className={s.input}
                onChange={(e) => handleAttrChange('instagram', e.target.value)}
              />
            </div>
            <div className={s.field}>
              <ApplyFormLabel attr='snapchat' label='Snap chat' />
              <input
                type='text'
                placeholder='youraccount'
                id='snapchat'
                name='snapchat'
                value={fieldValues.snapchat}
                className={s.input}
                onChange={(e) => handleAttrChange('snapchat', e.target.value)}
              />
            </div>
            <div className={s.field}>
              <ApplyFormLabel attr='facebook' label='Facebook' />
              <input
                type='text'
                placeholder='youraccount'
                id='facebook'
                name='facebook'
                value={fieldValues.facebook}
                className={s.input}
                onChange={(e) => handleAttrChange('facebook', e.target.value)}
              />
            </div>
            <div className={s.field}>
              <ApplyFormLabel attr='twitter' label='Twitter' />
              <input
                type='text'
                placeholder='youraccount'
                id='twitter'
                name='twitter'
                value={fieldValues.twitter}
                className={s.input}
                onChange={(e) => handleAttrChange('twitter', e.target.value)}
              />
            </div>
          </div>
          <div className={s.column}>
            <div className={s.field}>
              <ApplyFormLabel attr='tiktok' label='TikTok' />
              <input
                type='text'
                placeholder='youraccount'
                id='tiktok'
                name='tiktok'
                value={fieldValues.tiktok}
                className={s.input}
                onChange={(e) => handleAttrChange('tiktok', e.target.value)}
              />
            </div>
            <div className={s.field}>
              <ApplyFormLabel attr='youtube' label='YouTube' />
              <input
                type='text'
                placeholder='youraccount'
                id='youtube'
                name='youtube'
                value={fieldValues.youtube}
                className={s.input}
                onChange={(e) => handleAttrChange('youtube', e.target.value)}
              />
            </div>
            <div className={s.field}>
              <ApplyFormLabel attr='website' label='Website' />
              <input
                type='text'
                placeholder='yourdomain.com'
                id='website'
                name='website'
                value={fieldValues.website}
                className={s.input}
                onChange={(e) => handleAttrChange('website', e.target.value)}
              />
            </div>
          </div>
        </div>
        <ApplyStepButtons back={goBack} />
      </form>
      <ApplyStepIcon step='5' />
    </div>
  )
}

export default ApplyFormSocial
